import React, { useEffect, useState } from "react";
import "./Poupup.css";

export default function PopupOnce() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const alreadyShown = localStorage.getItem("welcomePopupShown");

    if (!alreadyShown) {
      setTimeout(() => {
        setShowPopup(true);
        localStorage.setItem("welcomePopupShown", "true");
      }, 2000);
    }
  }, []);

  return (
    <>
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <button className="close-btn" onClick={() => setShowPopup(false)}>
              ✖
            </button>

            <h2 className="popup-title">קבלת כבר את<br/>המיתוג לערב לביבות?</h2>

            <p className="popup-text">
              בחינם! אמיתי, בחינם!
            </p>

            <a
              className="popup-link"
              href="https://diburhafakot.minisite.ms/1"
              target="_blank"
              rel="noopener noreferrer"
            >
             - כאן את מקבלת את זה -
            </a>

            <hr className="popup-divider" />

            <p className="popup-text">
              שימי ♥<br/>
              באזור האישי מחכה לך
              <br/>
              <strong>קופון 25% הנחה</strong><br/>
              על כל תוכניות חנוכה!
              <br/>
              (אורות בלבבות, תסובבי אותך, יריד הסופגניות, זינוק זיקוק פינוק)
            </p>
          </div>
        </div>
      )}
    </>
  );
}
